<template>
  <div class="container">
    <h1 class="title">Promotioncodes</h1>
    <h2 class="subtitle">
      Verwaltung der Promotioncodes
    </h2>

    <div class="columns">
      <div class="column is-8">
        <div class="buttons">
          <b-button
            icon-left="plus-circle"
            type="is-dark"
            @click="showBatchModal('p')"
            >mehrere einmal einlösbare %-Codes (TANs)</b-button
          >

          <b-button
            icon-left="plus-circle"
            type="is-dark"
            @click="showBatchModal('f')"
            >mehrere einmal einlösbare €-Codes (TANs)</b-button
          >
        </div>
      </div>

      <div class="column ">
        <div class="buttons buttons--end">
          <b-button
            icon-left="plus-circle"
            type="is-dark"
            @click="showModal('p')"
            >%-Code</b-button
          >

          <b-button
            icon-left="plus-circle"
            type="is-dark"
            @click="showModal('f')"
            >€-Code</b-button
          >
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field>
          <b-input
            placeholder="Suche..."
            icon="search"
            v-model="freeText"
            @keyup.enter.native="search"
          >
          </b-input>
        </b-field>
      </div>
    </div>
    <ReductionTable
      :results="reductions"
      @request-delete="deleteCode"
      @request-page="pageChange"
      :pageSize="pageSize"
      :page="page"
      :total="total"
    />
    <CreateReductionModal
      :show="ModalVisible"
      @close="closeModal"
      :type="CreationalType"
    />

    <BatchCreateReductionsModal
      :show="BatchModalVisible"
      @close="closeBatchModal"
      :type="CreationalType"
    />
  </div>
</template>
<script>
import ReductionTable from '@/components/reductions/ReductionTable'
import CreateReductionModal from '@/components/reductions/CreateReductionModal'
import BatchCreateReductionsModal from '@/components/reductions/BatchCreateReductionsModal'
import reductionApi from '@/api/reduction-api'
export default {
  name: 'Reductions',
  components: {
    ReductionTable,
    CreateReductionModal,
    BatchCreateReductionsModal,
  },
  data() {
    return {
      CreationalType: '',
      ModalVisible: false,
      BatchModalVisible: false,
      reductions: [],
      page: 1,
      pageSize: 16,
      total: 0,
      freeText: '',
    }
  },
  async mounted() {
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      const result = await reductionApi.getReductions(
        this.page,
        this.pageSize,
        'default',
        this.freeText,
        null,
      )
      this.reductions = result.results
      this.page = result.page
      this.pageSize = result.pageSize
      this.total = result.total
    },
    showModal(t) {
      this.CreationalType = t
      this.ModalVisible = true
    },
    showBatchModal(t) {
      this.CreationalType = t
      this.BatchModalVisible = true
    },
    closeModal(item) {
      this.ModalVisible = false
      if (item) {
        this.reductions.push(item)
      }
    },
    closeBatchModal(items) {
      this.BatchModalVisible = false
      if (items) {
        for (let i = 0; i < items.length; i++) {
          this.reductions.push(items[i])
        }
      }
    },
    async pageChange(page) {
      this.page = page
      await this.refreshData()
    },
    async search() {
      await this.refreshData()
    },
    async deleteCode(item) {
      await reductionApi.deleteReduction(item.id)
      this.reductions = this.reductions.filter(f => f.id != item.id)
      this.$buefy.toast.open('Gelöscht!')
    },
  },
}
</script>
